module.exports = __webpack_public_path__ + "static/media/bicycle_video.a2630796.jpg";